import { useMemo } from 'react';
import { usePlanCardContext } from '../../../context';

export function useCreditRate(): string | null {
  const { isPaid, selectedPlan } = usePlanCardContext();

  return useMemo(() => {
    if (!isPaid || !selectedPlan) return null;
    const amount = selectedPlan.amount ?? 0;
    const credits = Number(selectedPlan.metadata?.request) || 0;
    if (credits === 0) return null;
    const ratePer1K = (amount / credits) * 1000;
    return ratePer1K % 1 === 0 ? ratePer1K.toFixed(0) : ratePer1K.toFixed(2);
  }, [isPaid, selectedPlan]);
}
